export default {
    schedule_workOrder_customer: "Customer",
    schedule_workOrder_phone: "Phone",
    schedule_workOrder_email: "Email",
    schedule_workOrder_type: "Type",
    schedule_workOrder_description: "Description",
    schedule_workOrder_customer: "Customers",
    schedule_workOrder_workOrderNumber: "Work Order Number",
    schedule_workOrder_conflict: "You cannot assign more than one work order on the same date. ",
    schedule_workOrder_title_conflict: "Conflict",
    schedule_workOrder_move_message_error: "The work order date cannot be less than the current date or the assigned driver",
    schedule_workOrder_move_title_error: "Work order not moved",
    schedule_workOrder_address: "Address",
    workOrder_tab_advancedFilters_tags: "Tags",
    schedule_workOrder_drivers: "Drivers",
    schedule_workOrder_view_day: "Day",
    schedule_workOrder_view_week: "Week",
    schedule_workOrder_view_month: "Month",
    filters: "Filters",
    add: "Add"
}